// extracted by mini-css-extract-plugin
export default {"title":"Style_title__XEi1B","w100":"Style_w100__EHW2H","wrapper":"Style_wrapper__kYtF4","fontBold":"Style_fontBold__7TujE"};